<template>
    <FalconFrame />
</template>
<script setup lang="ts">
import { FalconFrame } from "@swisstiming/falcon-core";
</script>

<style lang="scss">
body {
    background-color: var(--color-surface-1);
}
</style>
